/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import { camelCase, isEmpty, isString } from 'lodash';

export const REQUEST_STATE_REQUESTED = 'REQUESTED';
export const REQUEST_STATE_RECEIVED = 'RECEIVED';
export const REQUEST_STATE_ERROR = 'ERROR';
export const CLEAR_REQUEST_STATUS = 'CLEAR_REQUEST_STATUS';

export const REQUEST_STATES = {
  requested: REQUEST_STATE_REQUESTED,
  received: REQUEST_STATE_RECEIVED,
  error: REQUEST_STATE_ERROR,
  clear: CLEAR_REQUEST_STATUS
};

const isValidRequestState = (type) =>
  Object.values(REQUEST_STATES).reduce(
    (bool, requestState) => bool || type.startsWith(requestState),
    false
  );

export const requestStatusReducer = (
  state = {},
  action,
  { requestStatus = {} }
) => {
  const { payload, type } = action;

  if (type === 'CLEAR_REQUEST_STATUS') {
    const newState = {
      ...state
    };
    delete newState[payload.requestStatus];
    return newState;
  }

  if (isEmpty(type) || !isValidRequestState(type)) {
    return state;
  }

  const [, actionTypeStatus, actionComponent] =
    type.match(/([A-Z]+)_(.*)/) || [];

  if (isString(actionComponent) && actionComponent !== '') {
    let requestStatusKey = camelCase(actionComponent);
    if (action.payload && action.payload.identifier) {
      const { identifier } = action.payload;
      requestStatusKey = `${requestStatusKey}_${identifier}`;
    }
    requestStatus[requestStatusKey] = actionTypeStatus;
  }
  return requestStatus;
};
